/** Role identifiers aligned with user_type_master.user_type values. */
export const ROLES = {
  SUPER_USER: "super user",
  HOSPITAL: "hospital",
  DOCTOR: "doctor",
  PATIENT: "patient",
  SERVICE_PROVIDER: "service provider",
  HCF: "hcf",
};

const normalizeRole = (value) => (value || "").toString().trim().toLowerCase();

export const getRoleFromUser = (user) => normalizeRole(user?.user_type);

export const isSuperUser = (user) => {
  if (!user) return false;
  if (Number(user.user_type_id) === 1) return true;
  const role = getRoleFromUser(user);
  return role === ROLES.SUPER_USER || role.includes("super");
};

export const isHospitalAdmin = (user) => {
  if (!user || user.doctor_id) return false;
  if (Number(user.user_type_id) === 3) return true;
  const role = getRoleFromUser(user);
  return role === ROLES.HOSPITAL || role.includes("hospital");
};

export const isDoctorAdmin = (user) => {
  if (!user) return false;
  if (user.doctor_id) return true;
  if (Number(user.user_type_id) === 2) return true;
  const role = getRoleFromUser(user);
  return role === ROLES.DOCTOR || role.includes("doctor");
};

export const canAccessAdminDashboard = (user) =>
  isSuperUser(user) || isHospitalAdmin(user) || isDoctorAdmin(user);
